import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { TRADEOFF_URL, ASSETS } from "@/lib/site";

export const FeaturedProduct = () => {
  return (
    <section
      id="featured-product"
      data-testid="featured-product-section"
      className="py-20 md:py-32 bg-brand-navy-deep text-white overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="text-xs font-semibold tracking-[0.2em] uppercase text-brand-sky">
                Featured product
              </p>
              <h2 className="mt-4 font-heading font-800 text-4xl sm:text-5xl tracking-tight text-white">
                Trade Off
              </h2>
              <p className="mt-5 text-xl leading-relaxed text-slate-200">
                The simple platform built for UK subcontractors — takeoff,
                estimating and getting paid, all in one place.
              </p>
              <p className="mt-4 leading-relaxed text-slate-400">
                Measure straight from your blueprints, build accurate estimates
                in minutes, and send professional Applications for Payment your
                clients can settle in a click. Trade Off is our first live
                production application, built for how subcontractors actually
                work.
              </p>
              <a
                data-testid="featured-view-tradeoff-cta"
                href={TRADEOFF_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex items-center gap-2 bg-white text-brand-navy font-semibold px-7 py-3.5 rounded-lg hover:bg-slate-100 transition-colors"
              >
                View Trade Off
                <ArrowUpRight className="h-5 w-5" strokeWidth={2} />
              </a>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.12}>
              <div
                data-testid="tradeoff-mockup"
                className="relative rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm p-3 shadow-2xl"
              >
                <div className="flex items-center gap-2 px-3 py-2.5">
                  <span className="h-3 w-3 rounded-full bg-white/25" />
                  <span className="h-3 w-3 rounded-full bg-white/25" />
                  <span className="h-3 w-3 rounded-full bg-white/25" />
                  <span className="ml-3 text-xs text-slate-400 font-medium">
                    tradeoff.blueshuckconsulting.com
                  </span>
                </div>
                <a
                  href={TRADEOFF_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block rounded-xl overflow-hidden border border-white/10 group"
                  aria-label="Open the Trade Off application"
                >
                  <img
                    src={ASSETS.tradeoffMockup}
                    alt="Trade Off application interface showing a blueprint takeoff canvas with measurements and an estimate breakdown"
                    className="w-full h-auto block transition-transform duration-500 group-hover:scale-[1.02]"
                  />
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
